import { createContext, useContext, useState } from 'react'

import { getTMinus1, toISO8601 } from '@fortem-monorepo/js-utilities'
import type { AccruedInterests } from '@fortem-monorepo/web-sdk'

import { type BalanceDrafts, clearBalanceDrafts, getBalanceDrafts, stageBalanceDraft } from './balance-drafts'

type ChartSelection = {
  fund_name: string
  instrument_id: number
}

export const useCreateAccruedInterestsContext = () => {
  const [activeTab, setActiveTab] = useState('daily')
  const [chartSelection, setChartSelection] = useState<ChartSelection | null>(null)
  const [params, setParams] = useState<AccruedInterests.Params>(() => ({
    fund_name: '',
    value_date: toISO8601(getTMinus1()),
  }))
  const [drafts, setDrafts] = useState<BalanceDrafts>({})

  return {
    activeTab,
    setActiveTab,
    chartInstrumentId: chartSelection?.fund_name === params.fund_name ? chartSelection.instrument_id : 0,
    setChartInstrumentId: (instrument_id: number) => setChartSelection({ fund_name: params.fund_name, instrument_id }),
    params,
    setParams,
    balanceDrafts: getBalanceDrafts(drafts, params),
    stage: (
      params: AccruedInterests.Params,
      row: AccruedInterests.BalanceRow,
      override: AccruedInterests.BalanceOverride,
    ) => setDrafts((current) => stageBalanceDraft(current, params, row, override)),
    clearDrafts: (params: AccruedInterests.Params, tradeIds?: string[]) =>
      setDrafts((current) => clearBalanceDrafts(current, params, tradeIds)),
  }
}

export const AccruedInterestsContext = createContext<ReturnType<typeof useCreateAccruedInterestsContext> | null>(null)

export const useAccruedInterestsContext = () => {
  const context = useContext(AccruedInterestsContext)

  if (!context) throw new Error('useAccruedInterestsContext requires AccruedInterestsProvider')

  return context
}
